// extracted by mini-css-extract-plugin
module.exports = {"image":"BigPicture_image__PWw4n"};